export const EditVehicleModalList = [
    {
        label: "車牌號",
        value: 'plate',
        key: "plate",
        type: "text",
        placeholder: "例：ABC-1234、ABC1234",
        required: false,
        disabled: false
    },
    {
        label: "車型",
        value: 'model',
        key: "model",
        type: "text",
        placeholder: "例：Toyota Hiace",
        required: true,
        disabled: false
    },
    {
        label: "噸數",
        value: 'tonnage',
        key: "tonnage",
        type: "number",
        placeholder: "例：2.5",
        required: true,
        disabled: false,
        step: "0.1"
    },
    // {
    //     label: "所屬員工 ID",
    //     value: 'employeeId',
    //     key: "employeeId",
    //     type: "number",
    //     placeholder: "員工 ID",
    //     required: false,
    //     disabled: false
    // },
    {
        label: "升降尾門",
        value: 'hasTailLift',
        key: "hasTailLift",
        type: "select",
        required: false,
        disabled: false,
        options: [
            { value: 0, label: "否" },
            { value: 1, label: "是" }
        ]
    },
    {
        label: "司機",
        value: 'employeeId',
        key: "employeeId",
        type: "select",
        required: true,
        disabled: false,
        isAsync: true,
        apiName: "getDeliver",
        displayField: "name",
        valueField: "id"
    },
]

export const CreateVehicleModalList = [
    {
        label: "車牌號",
        name: "plate",
        type: "text",
        placeholder: "例：ABC-1234、ABC1234",
        required: true,
    },
    {
        label: "車型",
        name: "model",
        type: "text",
        placeholder: "例：Toyota Hiace",
        required: true,
    },
    {
        label: "噸數",
        name: "tonnage",
        type: "number",
        placeholder: "例：2.5",
        required: true,
        step: "0.1"
    },
    // {
    //     label: "所屬員工 ID",
    //     name: "employeeId",
    //     type: "number",
    //     placeholder: "員工 ID",
    //     required: false,
    // },
    {
        label: "升降尾門",
        name: "hasTailLift",
        type: "select",
        required: false,
        options: [
            { value: 0, label: "否" },
            { value: 1, label: "是" }
        ]
    },
    {
        label: "司機",
        name: "employeeId",
        type: "select",
        required: true,
        isAsync: true,
        apiName: "getDeliver",
        displayField: "name",
        valueField: "id"
    },
]
